import { UsrclkSearchCondition } from 'components/SearchSideBar/types';
import { SelectedCurrentConditionType } from 'types/searchCondition';

/**
 * 計測用urlで使うクエリと対応する条件が選択されているかの配列を生成
 * @param selectedSearchCondition
 * @returns {query: '-ocL', isSelected: true}
 */
export const createUsrclkConditionQuery = (
  selectedSearchCondition: SelectedCurrentConditionType
) => {
  const pickupHoliday = selectedSearchCondition.holidayAndWayOfWorking.filter(
    (code) => code === '1' || code === '2'
  );

  const pickUpRequirement = selectedSearchCondition.requirements.filter(
    (code) => code === '1' || code === '2' || code === '4' || code === '3'
  );

  const conditionQueryList: UsrclkSearchCondition[] = [
    {
      query: '-ocL',
      isSelected: Boolean(selectedSearchCondition.searchJobTypeLId.length),
    },
    {
      query: '-ocM',
      isSelected: Boolean(selectedSearchCondition.searchJobTypeMId.length),
    },
    {
      query: '-ocS',
      isSelected: Boolean(selectedSearchCondition.searchJobTypeSId.length),
    },
    {
      query: '-locArea',
      isSelected: Boolean(selectedSearchCondition.areaId.length),
    },
    {
      query: '-locPrefecture',
      isSelected: Boolean(selectedSearchCondition.prefectureId.length),
    },
    {
      query: '-locCity',
      isSelected: Boolean(
        selectedSearchCondition.cityId.length ||
          selectedSearchCondition.wardId.length
      ),
    },
    {
      query: '-route',
      isSelected: Boolean(selectedSearchCondition.routeId.length),
    },
    {
      query: '-station',
      isSelected: Boolean(selectedSearchCondition.stationId.length),
    },
    {
      query: '-indL',
      isSelected: Boolean(selectedSearchCondition.industryLId.length),
    },
    {
      query: '-indS',
      isSelected: Boolean(selectedSearchCondition.industrySId.length),
    },
    {
      query: '-employment',
      isSelected: Boolean(selectedSearchCondition.employmentStatus.length),
    },
    {
      query: '-incomeMin',
      isSelected: Boolean(selectedSearchCondition.lowerLimitIncome),
    },
    {
      query: '-incomeMax',
      isSelected: Boolean(selectedSearchCondition.upperLimitIncome),
    },
    {
      query: '-kodawari',
      isSelected: Boolean(
        selectedSearchCondition.isNewArrival ||
          selectedSearchCondition.isNearDeadline ||
          pickupHoliday.length ||
          pickUpRequirement.length
      ),
    },
    {
      query: '-kwdInclude',
      isSelected: Boolean(selectedSearchCondition.includedKeyword.length),
    },
    {
      query: '-kwdExclude',
      isSelected: Boolean(selectedSearchCondition.excludedKeyword.length),
    },
    {
      query: '-recruitment',
      isSelected: Boolean(selectedSearchCondition.requirements.length),
    },
    {
      query: '-environment',
      isSelected: Boolean(selectedSearchCondition.workplaceEnvironment.length),
    },
    {
      query: '-treatment',
      isSelected: Boolean(selectedSearchCondition.welfareBenefits.length),
    },
    {
      query: '-language',
      isSelected: Boolean(selectedSearchCondition.languageSkills.length),
    },
    {
      query: '-offerDetail',
      isSelected: Boolean(selectedSearchCondition.positions.length),
    },
    {
      query: '-averageAge',
      isSelected: Boolean(selectedSearchCondition.employeeAverageAge.length),
    },
    {
      query: '-holiday',
      isSelected: Boolean(
        selectedSearchCondition.holidayAndWayOfWorking.length
      ),
    },
    {
      query: '-employee',
      isSelected: Boolean(selectedSearchCondition.employNum.length),
    },
    {
      query: '-establish',
      isSelected: Boolean(selectedSearchCondition.establish.length),
    },
    {
      query: '-applicant',
      isSelected: Boolean(selectedSearchCondition.jobOfferKind),
    },
  ];

  return conditionQueryList;
};
